module.exports = __webpack_public_path__ + "img/review-user.3ff1df18.svg";